<template>
    <div class="main">
        <div class="coach-info">
            <div class="clear coach-info__hd bcw">
                <div class="left">
                    <div class="c4 fs3">{{ coachInfo.realName }}</div>
                    <div class="fs2 c9"><van-rate class="left" v-model="coachInfo.rating" :size="13" disabled-color="#FF6F0F" disabled /> 
                    &nbsp;/ 累计上课{{ coachInfo.lessons }}课时</div>
                </div>
                <div class="right coach-info__avatar">
                    <img v-if="coachInfo.avatar" :src="coachInfo.avatar">
                    <img v-if="coachInfo.avatar==''" :src="coachInfo.user.largeAvatar">
                    <img v-if="!coachInfo.avatar && coachInfo.user && coachInfo.user.largeAvatar" src="https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=3036298910,569278160&fm=27&gp=0.jpg" alt="">
                    <!-- <i v-else class="iconfont">&#xe6a7;</i> -->
                </div>
            </div>
            <van-row class="coach-info__bd tac bcw">
                <van-col span="8">
                    <div @click="goCoachentry()">
                    <div class="coach-info__bd--icon">
                        <!-- <i class="iconfont">&#xe630;</i> -->
                        <img class="img" src="../assets/imgs/xinrui.jpg" alt="">
                    </div>
                    <div class="mtn c6 fs2">新锐教练认证</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div @click="goLevel()">
                    <div class="coach-info__bd--icon">
                        <div class="img">
                            <img src="../assets/imgs/grade.png" alt="">
                            <span class="gradeNum fs2">p1</span>
                        </div>
                    </div>
                    <div class="mtn c6 fs2">教练等级</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div @click="goVip()">
                        <div class="coach-info__bd--icon"><img class="img" src="../assets/imgs/member.jpg" alt=""></div>
                        <div class="mtn c6 fs2">黄金会员</div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="model-box bcw">
            <div class="model-box__hd clear">
                <h3 class="left">签约俱乐部</h3>
            </div>
            <div class="model-box__bd fs2 c6 mtm clear">
                <club-card v-for="item in coachClubList" :key="item.id" :club="item"></club-card>                
            </div>
        </div>
        <div class="model-box bcw mtm">
            <div class="model-box__hd clear">
                <h3 class="left">教练简介</h3>
            </div>
            <div class="model-box__bd fs2 c6 mtm clear" v-html="coachInfo.desc"></div>
        </div>
        <!-- <div class="model-box mtm bcw">
            <div class="model-box__hd clear">
                <h3 class="left">私教课</h3>
            </div>
            <div class="model-box__bd fs2 c6 mtm clear">
                <van-row gutter="20">
                    <van-col v-for="item in coachCourseList" :key="item.id" span="12">
                        <router-link :to="{name:'coachcourseitem',params: { courseId: item.id}}" class="private-card">
                            <div class="private-card__pic">
                                <img v-if="item.picture" :src="item.picture">
                                <img v-else src="../assets/imgs/true.jpg">
                            </div>
                            <div class="fs3 mtn c4 private-card__uname">{{item.title}}</div>
                            <div class="fs1 private-card__dis mtn">
                                <span class="price fs2">￥{{item.price}}/课时</span>
                                <span class="buy"><button class="van-button van-button--warning van-button--small">购买</button></span>
                            </div>
                        </router-link>
                    </van-col>
                </van-row>
            </div>
        </div> -->
        <the-tabbar></the-tabbar>
    </div>
</template>
<script>
import Vue from 'vue';
import { Rate } from 'vant';
import CourseCard from '@/components/CourseCard';
import TheTabbar from '@/components/TheTabbar';
import ClubCard from '@/components/ClubCard';
Vue.use(Rate);

export default {
    name: 'CoachItem',
    components:{
        CourseCard,TheTabbar,ClubCard
    },
    data(){
      return {
        coachInfo:{}, //教练信息
        coachClubList:{},//教练俱乐部列表
        coachCourseList:{}//教练私教课列表
      }
    },
    created(){
        // 取团课列表数据
        let _this = this;  //?为什么直接用this会报错？？
        this.$http.get('club_coach/getCoachInfo?coachId=' + this.$route.params.coachId).then(function(res){
            console.log(res)
            _this.coachInfo = res.data.value.coachInfo
            if(_this.coachInfo.rating == '' || _this.coachInfo.rating==0){
                _this.coachInfo.rating = 5
            }
            _this.coachClubList = res.data.value.clubList
            _this.coachCourseList = res.data.value.courseList
        })
    },
    methods:{        
        goVip:function(){
            location.href=`${location.origin}`+'/m/vip'   
        },
        goLevel:function(){
            location.href=`${location.origin}`+'/training/#/levelVerify'   
        },
        goCoachentry:function(){
            this.$router.push({name: 'coachentry'})
        }
    }
}
</script>

<style lang="less">
.coach-info{
    padding: .15rem;
    background: url('../assets/imgs/coach_bg1.png') center center;
    &__hd{
        padding: .1rem .15rem;
        line-height: .25rem;
        &>div:first-child{
            margin-right: .1rem;
        }
    }
    &__avatar{
        width: .5rem; height: .5rem; line-height: .5rem;
        background-color: #f6f6f6;
        text-align: center;
        border-radius: 50%;
        overflow: hidden;
        &>img{
            width: 100%; height: 100%;
            object-fit: cover;
            filter: blur(0px);
        }
    }
    &__bd{
        padding: .15rem;
        &--icon{
            position: relative;           
            &>.img{
                margin: -0.1rem auto 0;
                height: 0.5rem;
                &>img{
                    width: .4rem;margin:auto;position: absolute;top: 50%;left: 50%;
                    transform: translate(-50%,-50%);
                }
            }
            & .gradeNum{
                position: absolute;
                top: 50%;left: 50%;
                transform: translate(-50%,-50%);
                color: #ffa31b;
            }
            &>.iconfont{
                font-size: .24rem;
            }
        }
    }
}
// 私教课卡片
.private-card{
    position: relative;
    display: block;
    text-align: left;
    margin: 0 0 0.15rem 0;
    box-shadow: rgba(0, 0, 0, 0.2) 0 0 0.05rem;
    padding: .1rem .1rem .15rem;
    &__pic{
        width: 100%;height: 1.5rem;border-radius:.03rem;
        overflow: hidden;background-color:#f6f6f6;
        &>img{
            width: 100%;height: 100%;object-fit: cover;
        }
    }
    &__dis{
        & .price{
            color:#FFA800;
        }
        & .buy button{
            position: absolute;
            right: .1rem;
            bottom: .15rem;
            height: .22rem;
            min-width: .4rem;
            line-height: 0.1rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/CoachItem.vue